import type { MediaKind, MediaStatus, PropertyStatus, PropertyType } from "@elektr/shared";

// Kalitlar literal yozilgan: i18n testi manba kodidan ularni topib, uz/ru'da borligini tekshiradi
export const STATUS_KEYS: Record<PropertyStatus, string> = {
  draft: "status.draft",
  ready: "status.ready",
  archived: "status.archived",
};
export const STATUS_TONE: Record<PropertyStatus, "warning" | "success" | "neutral"> = {
  draft: "warning",
  ready: "success",
  archived: "neutral",
};
export const TYPE_KEYS: Record<PropertyType, string> = {
  apartment: "type.apartment",
  house: "type.house",
  office: "type.office",
  other: "type.other",
};
export const KIND_KEYS: Record<MediaKind, string> = {
  photo: "kind.photo",
  video: "kind.video",
  scheme: "kind.scheme",
  document: "kind.document",
};
export const MEDIA_STATUS_KEYS: Record<MediaStatus, string> = {
  pending: "mstatus.pending",
  uploaded: "mstatus.uploaded",
  processing: "mstatus.processing",
  ready: "mstatus.ready",
  failed: "mstatus.failed",
};
export const MEDIA_STATUS_TONE: Record<MediaStatus, "neutral" | "info" | "success" | "danger"> = {
  pending: "neutral",
  uploaded: "info",
  processing: "info",
  ready: "success",
  failed: "danger",
};
